import React, { useEffect, useState } from "react";
import { noticeAlert } from "../../Datas/SiteData/AllinOne";
import { useRef } from "react";

const NoticeAlert = () => {
  const [isNoticeClosed, setIsNoticeClosed] = useState(false);
  const [notice, setNotice] = useState("");
  const noticeRef = useRef(null);
  useEffect(() => {
      setNotice(noticeAlert);
  }, []);
  useEffect(() => {
    noticeRef.current.innerHTML = notice;
  }, [notice]);
  return (
    <div
      className={`duration-150 transition-all  w-full md:container origin-top p-2  mx-auto overflow-hidden  my-10 ${
        isNoticeClosed && "hidden"
      }`}
    >
      <div
        className="dark:dark-bg-front bg-front mb-4 box bg-primary-100 p-10 text-base text-primary-600  relative pl-10"
        role="alert"
      >
        <i
          className="fa fa-times absolute top-2 right-2 cursor-pointer w-5 h-5 hover:border hover:text-brand hover:border-orange-300  flex justify-center items-center duration-150 text-2xl"
          aria-hidden="true"
          onClick={() => setIsNoticeClosed(true)}
        ></i>
        <div className="w-full h-full description-output" ref={noticeRef}></div>
      </div>
    </div>
  );
};

export default NoticeAlert;
